import { render, staticRenderFns } from "./live-results.vue?vue&type=template&id=41f4f4b6&scoped=true&lang=pug"
import script from "./live-results.vue?vue&type=script&lang=coffee"
export * from "./live-results.vue?vue&type=script&lang=coffee"
import style0 from "./live-results.vue?vue&type=style&index=0&id=41f4f4b6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f4f4b6",
  null
  
)

export default component.exports